import React, { ReactNode } from 'react';

export const AdditionalSettings = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}): JSX.Element => {
  return <>{children}</>;
};
